import styled from '@emotion/styled';
import { ListItemIcon as MuiListItemIcon, MenuItem as MuiMenuItem, Typography } from '@mui/material';
import { ReactNode } from 'react';

export const MenuItem = styled(MuiMenuItem)`
    border-radius: 8px;
    padding: 1rem;
`;

export const ListItemIcon = styled(MuiListItemIcon)`
    min-width: 3.2rem !important;
`;

export const ArrowRight = styled.div`
    margin-left: 1rem;
`;

export const ListItemText = ({ children, className }: { children: ReactNode; className?: string }) => {
    return (
        <Typography variant="h5" fontWeight={600} className={className}>
            {children}
        </Typography>
    );
};

export const RedListItemText = styled(ListItemText)`
    color: ${({ theme }) => theme.colors.error.main};
`;
